module.exports = __webpack_public_path__ + "img/lineup11@2x.63ff5770.png";